<div class="filterforall" id="top-sort-list-wrapper">
    <div class="topmisty" id="top-sort-list-1">
        <div class="col-xs-12 nopad">
            <div class="divinsidefltr">
                <div class="insidemyt col-xs-12">
                    <ul class="sortul">
                        <!-- <li class="sortli hide_lines">
                            <a (click)="sortByAirlines()" class="sorta name-l-2-h loader c-pointer" 
                            [ngClass]="airlines && active == 'airlines' ? 'des active' :(active == 'airlines' ? 'asc active' : 'asc')">
                                <i class="fa fa-plane"></i>
                                <strong>Airline</strong>
                            </a>
                        </li> -->
                        <li class="sortli">
                            <a (click)="sortByPrice()" class="sorta name-l-2-h loader c-pointer" 
                            [ngClass]="price && active == 'price' ? 'des active' :(active == 'price' ? 'asc active' : 'asc')">
                                <i class="fa fa-tag"></i>
                                <strong>Price</strong>
                            </a>
                        </li>
                        <li class="sortli hide_lines">
                            <a (click)="sortByDuration()" class="sorta name-l-2-h loader c-pointer" 
                            [ngClass]="duration && active == 'duration' ? 'des active' :(active == 'duration' ? 'asc active' : 'asc')">
                                <i class="fas fa-clock"></i>
                                <strong>Duration</strong>
                            </a>
                        </li>
                        <li class="sortli">
                            <a (click)="sortByDepartureTime()" class="sorta name-l-2-h loader c-pointer" 
                            [ngClass]="departureTime && active == 'departureTime' ? 'des active' :(active == 'departureTime' ? 'asc active' : 'asc')">
                                <i class="fa fa-calendar"></i>
                                <strong>Schedule </strong>
                            </a>
                        </li>
                        <!-- <li class="sortli">
                            <a (click)="sortByDepartureTime()" class="sorta name-l-2-h loader c-pointer" 
                            [ngClass]="departureTime && active == 'departureTime' ? 'des active' :(active == 'departureTime' ? 'asc active' : 'asc')">
                                <i class="fa fa-calendar"></i>
                                <strong>Depart</strong>
                            </a>
                        </li>
                        
                        <li class="sortli">
                            <a (click)="sortByArrivalTime()" class="sorta name-l-2-h loader c-pointer"
                            [ngClass]="arrivalTime && active == 'arrivalTime' ? 'des active' :(active == 'arrivalTime' ? 'asc active' : 'asc')">
                                <i class="fa fa-calendar"></i>
                                <strong>Arrive</strong>
                            </a>
                        </li> -->
                       
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>